import {
  FIND_PRODUCT_BY_ID_FAILURE,
  FIND_PRODUCT_BY_ID_REQUEST,
  FIND_PRODUCT_BY_ID_SUCCESS,
  FIND_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE,
  FIND_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST,
  FIND_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS,
  FIND_PRODUCTS_BY_BRAND_FAILURE,
  FIND_PRODUCTS_BY_BRAND_REQUEST,
  FIND_PRODUCTS_BY_BRAND_SUCCESS,
  FIND_PRODUCTS_BY_OFFER_FAILURE,
  FIND_PRODUCTS_BY_OFFER_REQUEST,
  FIND_PRODUCTS_BY_OFFER_SUCCESS,
  FIND_PRODUCTS_FAILURE,
  FIND_PRODUCTS_REQUEST,
  FIND_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_REQUEST,
  GET_ALL_PRODUCTS_BY_BRAND_SUCCESS,
  GET_ALL_PRODUCTS_BY_CATEGORY_FAILURE,
  GET_ALL_PRODUCTS_BY_CATEGORY_REQUEST,
  GET_ALL_PRODUCTS_BY_CATEGORY_SUCCESS,
  GET_ALL_PRODUCTS_BY_FILTER_FAILURE,
  GET_ALL_PRODUCTS_BY_FILTER_REQUEST,
  GET_ALL_PRODUCTS_BY_FILTER_SUCCESS,
  GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_FAILURE,
  GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_REQUEST,
  GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_SUCCESS,
  GET_ALL_PRODUCTS_BY_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_FAILURE,
  GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_REQUEST,
  GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_SUCCESS,
  GET_ALL_PRODUCTS_FAILURE,
  GET_ALL_PRODUCTS_REQUEST,
  GET_ALL_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_FAILURE,
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_REQUEST,
  GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_SUCCESS,
  GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_FAILURE,
  FIND_PRODUCTS_BY_VENDOR_REQUEST,
  FIND_PRODUCTS_BY_VENDOR_SUCCESS,
  FIND_PRODUCTS_BY_VENDOR_FAILURE,
  GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_REQUEST
} from "./ActionType";

const initialState = {
  products: [],
  allProducts: [],
  filterProducts: [],
  searchProducts: [],
  product: null,
  loading: false,
  getByIdLoading: false,
  error: null
};

export const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_PRODUCTS":
      return { ...state, filterProducts: { ...state.filterProducts, response: { products: [] } }, loading: true };

    case GET_ALL_PRODUCTS_REQUEST:
    case GET_ALL_PRODUCTS_BY_BRAND_REQUEST:
    case GET_ALL_PRODUCTS_BY_CATEGORY_REQUEST:
    case GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_REQUEST:
    case GET_ALL_PRODUCTS_BY_OFFERS_REQUEST:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST:
    case GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_REQUEST:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_REQUEST:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_REQUEST:
    case FIND_PRODUCTS_BY_BRAND_REQUEST:
    case FIND_PRODUCTS_BY_VENDOR_REQUEST:
    case FIND_PRODUCTS_BY_OFFER_REQUEST:
    case FIND_PRODUCTS_REQUEST:
    case FIND_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST:
    case GET_ALL_PRODUCTS_BY_FILTER_REQUEST:
    case GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_REQUEST:
    case SEARCH_PRODUCTS_REQUEST:
    case GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_REQUEST:
      return { ...state, loading: true, error: null };

    case FIND_PRODUCT_BY_ID_REQUEST:
      return { ...state, getByIdLoading: true, error: null };

    case GET_ALL_PRODUCTS_BY_BRAND_SUCCESS:
    case FIND_PRODUCTS_SUCCESS:
    case FIND_PRODUCTS_BY_OFFER_SUCCESS:
    case FIND_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS:
    case GET_ALL_PRODUCTS_BY_FILTER_SUCCESS:
    case GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_SUCCESS:
      return { ...state, loading: false, error: null, filterProducts: action.payload };

    case FIND_PRODUCTS_BY_BRAND_SUCCESS:
    case FIND_PRODUCTS_BY_VENDOR_SUCCESS:
    case GET_ALL_PRODUCTS_BY_OFFERS_SUCCESS:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS:
    case GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_SUCCESS:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_SUCCESS:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_SUCCESS:
    case GET_ALL_PRODUCTS_BY_CATEGORY_SUCCESS:
    case GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_SUCCESS:
      return { ...state, loading: false, error: null, products: action.payload };
      
    case GET_ALL_PRODUCTS_SUCCESS:
      return { ...state, loading: false, error: null, products: action.payload, allProducts: action.payload };

    case FIND_PRODUCT_BY_ID_SUCCESS:
      return { ...state, getByIdLoading: false, error: null, product: action.payload };

    case SEARCH_PRODUCTS_SUCCESS:
      return { ...state, loading: false, error: null, searchProducts: action.payload };

    case GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_SUCCESS:
      return { ...state, loading: false, error: null, searchProducts: action.payload };

    case GET_ALL_PRODUCTS_FAILURE:
    case GET_ALL_PRODUCTS_BY_CATEGORY_FAILURE:
    case GET_ALL_PRODUCTS_BY_BRAND_FAILURE:
    case GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_FAILURE:
    case GET_ALL_PRODUCTS_BY_OFFERS_FAILURE:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE:
    case GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_FAILURE:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_FAILURE:
    case GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_FAILURE:
    case FIND_PRODUCTS_BY_BRAND_FAILURE:
    case FIND_PRODUCTS_BY_VENDOR_FAILURE:
    case FIND_PRODUCTS_BY_OFFER_FAILURE:
    case FIND_PRODUCTS_FAILURE:
    case FIND_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE:
    case GET_ALL_PRODUCTS_BY_FILTER_FAILURE:
    case GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_FAILURE:
    case SEARCH_PRODUCTS_FAILURE:
    case GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FIND_PRODUCT_BY_ID_FAILURE:
      return { ...state, getByIdLoading: false, error: action.payload };

    default:
      return state;
  }
};
